<template>
  <v-expansion-panels>
    <v-expansion-panel
      :readonly="
        (resource.sentCount == 0 && resource.scheduledCount == 0) ||
          disableExpansion
      "
      class="rounded-lg card-border"
    >
      <v-expansion-panel-header
        class="py-0 overflow-hidden"
        :hide-actions="
          (resource.sentCount == 0 && resource.scheduledCount == 0) ||
            disableExpansion
        "
      >
        <template v-slot:default="{}">
          <v-row>
            <v-col class="py-6">
              <v-row dense>
                <v-col cols="auto" class="text-h6">
                  <a
                    :href="resource.url"
                    target="_blank"
                    class="secondary--text"
                  >
                    {{ resource.title }}
                  </a>
                </v-col>
                <v-col cols="auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        :color="resource.isFavorite ? 'error' : 'lighttext'"
                        @click="saveFavorite(resource.id, !resource.isFavorite)"
                        v-if="is_admin"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>favorite</v-icon>
                      </v-btn>
                      <v-icon
                        color="error"
                        small
                        v-else-if="resource.isFavorite"
                      >
                        favorite
                      </v-icon>
                    </template>
                    <div class="tooltip-limit-width">
                      Favorite
                    </div>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        :href="resource.url"
                        target="_blank"
                        color="lighttext"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>search</v-icon>
                      </v-btn>
                    </template>
                    <div class="tooltip-limit-width">
                      Preview
                    </div>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="
                          resource.sentCount == 0 &&
                            resource.companyId != null &&
                            is_admin
                        "
                        icon
                        small
                        @click="$emit('delete')"
                        color="lighttext"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <div class="tooltip-limit-width">
                      Delete
                    </div>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="auto" class="lighttext--text">
                  Added: {{ resource.createdDate | normalDate }} | By
                  {{ resource.author }}
                  <template
                    v-if="
                      resource.userRecords && resource.userRecords.finished > 0
                    "
                    >|
                    <router-link
                      :to="
                        `/reporting/training/overview/training/${resource.id}`
                      "
                      class="info--text"
                      >{{ resource.userRecords.finished }} Views</router-link
                    >
                  </template>
                </v-col>
              </v-row>
            </v-col>
            <v-spacer class="limited-spacer"></v-spacer>
            <template v-if="resource.sentCount == 0">
              <v-col cols="auto" class="my-auto">
                <v-btn
                  outlined
                  @click="$emit('edit')"
                  v-if="resource.companyId != null && is_admin"
                  color="lighttext"
                >
                  <v-icon color="secondary">edit</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="auto" class="my-auto">
                <v-btn outlined @click="showSchedule(null)" color="lighttext">
                  <v-icon color="secondary">send</v-icon>
                </v-btn>
              </v-col>
            </template>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="pa-0">
        <v-row
          class="text-center justify-space-around"
          v-if="resource.sentCount > 0"
        >
          <v-col cols="12" sm="6" md="3">
            <v-card outlined height="100%" class="d-flex">
              <v-card-text class="my-auto">
                <v-avatar
                  color="lighttext"
                  class="mr-2 text-h6 font-weight-medium"
                >
                  {{ resource.sentCount }}
                </v-avatar>
                Unique Sends
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card
              outlined
              height="100%"
              class="d-flex"
              :to="
                `/reporting/training/overview/training/${resource.id}?showRecipients=true`
              "
            >
              <v-card-text class="my-auto">
                <engagement-text
                  title="Participation Rate"
                  :engagement="resource.userRecords"
                ></engagement-text>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card
              outlined
              height="100%"
              class="d-flex"
              :to="`/reporting/training/overview/training/${resource.id}`"
            >
              <v-card-text class="my-auto secondary--text">
                <v-icon class="mr-2" color="secondary">insert_chart</v-icon>
                View Report
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card
              outlined
              height="100%"
              class="d-flex"
              @click="showSchedule(null)"
            >
              <v-card-text class="my-auto secondary--text">
                <v-icon class="mr-2" color="secondary">send</v-icon>
                Schedule Send
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <resource-card-schedules
          :resource="resource"
          v-on:edit="showSchedule"
          v-on:delete="deleteSchedule"
        >
        </resource-card-schedules>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <resource-schedule-dialog
      :resourceId="resource.id"
      ref="scheduleDialog"
    ></resource-schedule-dialog>
  </v-expansion-panels>
</template>

<script>
import { mapGetters } from "vuex";
import ResourceScheduleDialog from "@/components/resources/ResourceScheduleDialog";
import ResourceCardSchedules from "@/components/resources/ResourceCardSchedules";
import EngagementText from "@/components/reporting/EngagementText";
import resourceStatuses from "@/helpers/mixins/resourceStatuses";
export default {
  name: "ResourceCard",
  components: {
    ResourceScheduleDialog,
    EngagementText,
    ResourceCardSchedules
  },
  props: {
    resource: { type: Object },
    disableExpansion: { type: Boolean, default: false }
  },
  mixins: [resourceStatuses],
  computed: {
    ...mapGetters({
      is_admin: "profile/is_admin"
    })
  },
  methods: {
    loadSchedules() {
      this.$store.dispatch("resource/getResourceSchedules", this.resource.id);
    },
    showSchedule(instanceId) {
      this.$refs.scheduleDialog.showDialog(this.resource.id, instanceId);
    },
    saveFavorite(resourceId, value) {
      this.$store
        .dispatch("resource/saveFavorite", { id: resourceId, value })
        .then(() => {
          this.$root.$snackbarSuccess(
            value ? "Favorite added" : "Favorite removed"
          );
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while saving a favorite."
          );
        });
    },
    async deleteSchedule(scheduleId) {
      if (
        await this.$root.$confirm(
          "Delete scheduled resource",
          "Are you sure you want to delete this resource send?",
          { color: "red" }
        )
      ) {
        this.$store
          .dispatch("resource/deleteResourceSchedule", {
            resourceId: this.resource.id,
            id: scheduleId
          })
          .then(() => {
            this.$root.$snackbarSuccess("Resource send deleted");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting this resource send."
            );
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-chip {
  min-width: 100px;

  ::v-deep .v-chip__content {
    margin-left: auto;
    margin-right: auto;
  }
}

::v-deep .v-expansion-panel-header__icon i {
  color: var(--v-secondary-base) !important;
}

.badge-background {
  position: absolute;
  bottom: -50px;
  right: 65px;
}

::v-deep .cls-1 {
  fill: inherit !important;
}
</style>
